import { render, staticRenderFns } from "./UploadOverlay.vue?vue&type=template&id=6cfc4bbf&scoped=true&"
import script from "./UploadOverlay.vue?vue&type=script&lang=js&"
export * from "./UploadOverlay.vue?vue&type=script&lang=js&"
import style0 from "./UploadOverlay.vue?vue&type=style&index=0&id=6cfc4bbf&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6cfc4bbf",
  null
  
)

export default component.exports